module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "no-header",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-header": "true",
      "hide-footer": true,
      "title": "1-9 van 9 Urenregistraties"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('hour-registration-table', {
    ref: "registrationTable",
    attrs: {
      "userId": _vm.userId,
      "role": "admin"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b152d262","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/users/HourRegistrationModal.vue
// module id = 749
// module chunks = 1